<template>
    <el-container class="order-summary-record"> 
        <div class="headerCom"> 
          <publicBreadCrumb  :breadList="breadList"/> 
        </div>
        <el-main class="record">
            <el-scrollbar style="height: 100%">
                <div class="record-content record-summary" v-for="item in recordAll" :key="item.orderType">
                    <div class="record-header">
                        <div class="title">{{ item.orderTypeName }}<span v-if="item.orderType !== 0">订单</span></div>
                        <div class="header-right">
                            <div class="time">
                                <span :class="item.timeStatus == 1 ? 'active' : ''" @click="getTimeData(item.orderType, 1)">今日</span>
                                <span :class="item.timeStatus == 2 ? 'active' : ''" @click="getTimeData(item.orderType, 2)">本周</span>
                                <span :class="item.timeStatus == 3 ? 'active' : ''" @click="getTimeData(item.orderType, 3)">本月</span>
                                <span :class="item.timeStatus == 4 ? 'active' : ''" @click="getTimeData(item.orderType, 4)">全年</span>
                            </div>
                            <el-date-picker
                                v-model="item.timeRage"
                                type="daterange"
                                size="mini"
                                value-format="yyyy-MM-dd 00:00:00"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                @change="val => timeRageChange(val, item.orderType)">
                            </el-date-picker>
                            <div class="btn">
                                <el-button size="mini" type="primary" @click="exportExcel(item.orderType)">导出 Excel</el-button>
                            </div>
                        </div>
                    </div>
                    <el-tabs v-model="item.activeName" @tab-click="val => tabClick(val, item.orderType)">
                        <el-tab-pane v-for="(items, key) in platformList" :key="key" :label="items.label" :name="items.value">
                            <div class="order">
                                <div class="order-item">
                                    <span>总订单量</span>
                                    <div>{{ item.totalOrderNum }} <span>笔</span></div>
                                </div>
                                <div class="order-item">
                                    <span>总订单金额</span>
                                    <div>{{ item.totalOrderSum }} <span>元</span></div>
                                </div>
                                <div class="order-item">
                                    <span>客单价</span>
                                    <div>{{ item.perCustomerTransaction }} <span>元</span></div>
                                </div>
                                <div class="order-item">
                                    <span>新增订单</span>
                                    <div>{{ item.newOrder }} <span>笔</span></div>
                                </div>
                                <div class="order-item">
                                    <span>新增订单收入</span>
                                    <div>{{ item.newOrderIncome }} <span>元</span></div>
                                </div>
                                <div class="order-item">
                                    <span>退款订单</span>
                                    <div>{{ item.refundOrder }} <span>笔</span></div>
                                </div>
                                <div class="order-item">
                                    <span>退款订单支出</span>
                                    <div>{{ item.refundOrderExpend }} <span>元</span></div>
                                </div>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </el-scrollbar>
        </el-main>
    </el-container>
</template>

<script>
import { queryOrderSumRecord, queryOrderByOrderTypeAndPlatformIdAndTime, exportOrderSumRecord, getPlatformList } from './api/orderPay'
import{ plateFormOn } from '@/api/acc.js'
export default {
    data() {
        return {
            breadList:[{name:'订单管理'},{name:'订单汇总记录'}],
            params: {
                timeStatus: 1,
                startTime: '',
                endTime: '',
                orderType: 0,
                hospitalId: 0
            },
            currentOrder: '0',
            recordAll: [],
            platformList: [{
                label: this.$store.state.userPlatForm === 'platForm' ? '全部机构' : '全部',
                value: this.$store.state.userPlatForm === 'platForm' ? '0' : this.$store.state.hospitalId
            }]
        }
    },
    created() {
      if (this.$store.state.userPlatForm === 'platForm') {
        // 平台
        this.getPlatformList()
      } else {
        // 机构
        this.params.hospitalId = this.$store.state.hospitalId
      }
      this.getInitData()
    },
    methods: {
        // 获取全部订单记录
        async getInitData() {
            let { code, data } = await queryOrderSumRecord({
              hospitalId: this.params.hospitalId
            })
            if (code === 0) {
                this.recordAll = data.map(item => {
                    return {
                        ...item,
                        orderTypeName: this.translateOrderType(item.orderType),
                        activeName: this.$store.state.userPlatForm === 'platForm' ? '0' : this.$store.state.hospitalId,
                        hospitalId: this.params.hospitalId,
                        timeStatus: 1,
                        startTime: '',
                        endTime: '',
                        timeRage: ''
                    }
                })
            }
        },
        // 获取单个平台或单个时间平台记录
        async getPlatformRecords(orderType, hospitalId, timeStatus, startTime, endTime) {
            let { code, data } = await queryOrderByOrderTypeAndPlatformIdAndTime({ ...this.params })
            if (code === 0) {
                // this.recordAll[orderType] = data
                Object.assign(this.recordAll[orderType], { ...data, hospitalId, timeStatus, startTime, endTime })
            }
        },
        // 获取平台列表
        async getPlatformList() {
            let { code, data } = await plateFormOn()
            if (code === 0) {
                // data.splice(0,1)
                data.map(item => {
                    this.platformList.push({
                        label: item.name,
                        value: item.id
                    })
                })
            }
        },
        getTimeData(orderType, index) {
            let item = this.recordAll[orderType]
            item.timeRage = ''
            item.timeStatus = index
            Object.assign(this.params, { ...this.params, timeStatus: index, orderType, startTime: '', endTime: '', hospitalId: item.hospitalId })
            this.getPlatformRecords(orderType, item.hospitalId, index, '', '')
        },
        // 日期范围选择
        timeRageChange(time, orderType) {
            let item = this.recordAll[orderType]
            item.timeRage = time
            item.timeStatus = 0
            let startTime = time ? time[0] : ''
            let endTime = time ? time[1] : ''
            Object.assign(this.params, { ...this.params, timeStatus: 0, startTime, endTime, orderType, hospitalId: item.hospitalId })
            this.getPlatformRecords(orderType, item.hospitalId, 0, startTime, endTime)
        },
        // 导出excel
        async exportExcel(orderType) {
            let res = await exportOrderSumRecord({ orderType, hospitalId:this.params.hospitalId })
            // 文件流
            let blob = new Blob([res], {
                type: 'application/vnd.ms-excel,charset=UTF-8' //将会被放入到blob中的数组内容的MIME类型
            });
            let objectUrl = URL.createObjectURL(blob);  //生成一个url
            this.downloadFile(objectUrl, `${this.excelName(orderType)}`)
        },
        downloadFile(content, filename) {
            let a = document.createElement('a')
            a.href = content
            a.download = filename
            a.click()
        },
        tabClick({ name }, orderType) {
            let item = this.recordAll[orderType]
            item.activeName = name
            item.hospitalId = name
            Object.assign(this.params, { ...this.params, orderType, hospitalId: name, timeStatus: item.timeStatus, startTime: item.startTime, endTime: item.endTime })
            this.getPlatformRecords(orderType, name, item.timeStatus, item.startTime, item.endTime)
        },
        translateOrderType(val) {
            switch(val) {
                case 0:
                    return '总订单概要'
                break;
                case 1:
                    return '方案/全病程'
                break;
                case 2:
                    return '药品'
                break;
                case 3:
                    return '问诊'
                break;
                case 4:
                    return '护理服务'
                break;
            }
        },
        excelName(orderType) {
            switch(orderType) {
                case 0:
                    return '总订单概要'
                break
                case 1:
                    return '全病程服务订单'
                break
                case 2:
                    return '药品订单'
                break
                case 3:
                    return '全病程问诊订单'
                break
                case 4:
                    return '医护上门服务订单'
                break
            }
        }
    }
}
</script>

<style lang="less">
.el-scrollbar__wrap {
    overflow-x: hidden
}
</style>

<style lang="less" scoped>
.order-summary-record {
    height: 100%;
    display: flex;
    flex-direction: column;

    .record {
        margin: 0 24px;
        padding: 0;
        .record-content {
            border-radius: 5px;
            background: #ffffff;
            padding: 15px;
            margin-top: 24px;
            &:first-child {
                margin-top: 0;
            }
            .record-header {
                display: flex;
                color: #333333;
                line-height: 2;
                .header-right {
                    width: 60%;
                    display: flex;
                    justify-content: flex-end;
                    .time {
                        span {
                            margin: 0 5px;
                            font-size: 14px;
                            &:hover {
                                color: #1A7BFC;
                                cursor: pointer;
                            }
                            &:first-child {
                                margin-left: 0;
                            }
                            &:last-child {
                                margin-right: 0
                            }
                            &.active {
                                color: #1A7BFC;
                            }
                        }
                    }
                    .el-date-editor {
                        margin: 0 10px;
                    }
                }
                .title {
                    flex: 1;
                    font-size: 16px;
                    font-weight: bold;
                }
            }
        }
    }
    .order {
        display: flex;
        justify-content: space-around;
        text-align: center;
        .order-item {
            width: 10%;
            line-height: 2;
            span {
                font-size: 12px;
                color: #666666;
            }
            div {
                font-size: 24px;
            }
        }
    }
}
</style>